const config = {
    apiBaseUrl: process.env.VUE_APP_API_ROOT
}

export default config
